export const eventEndpoint = 'v2/events';
export const eventCategoryEndpoint = 'v2/event-categories';
export const eventTagEndpoint = 'v2/event-tags';
export const eventAssistantEndpoint = 'assistants';
export const participantEndpoint = 'participants';
